import React, { FC } from 'react';
import * as StyledCtaBoxesWithDescription from './ctaBoxesWithDescription.styles';
import ICtaBoxWithDescription from '../../../interfaces/elements/ctaBoxWithDescription';
import { Columns, Column } from '../../base/grid';
import CtaBoxWithDescription from '../ctaBoxWithDescription';

interface Props {
	boxes: ICtaBoxWithDescription[];
}

const CtaBoxesWithDescription: FC<Props> = ({ boxes }) => {
	const desktopSize = boxes.length > 2 ? 4 : 2;
	return (
		<StyledCtaBoxesWithDescription.Wrapper>
			<Columns>
				{boxes.map((box, index) => (
					<Column tablet={1 / 2} desktopSmall={1 / desktopSize} key={index}>
						<CtaBoxWithDescription box={box} />
					</Column>
				))}
			</Columns>
		</StyledCtaBoxesWithDescription.Wrapper>
	);
};

export default CtaBoxesWithDescription;
